import React from "react";
import { createSetContainerDesktop, createSetMobile } from "./style.mod.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { CreateSetDesktop, CreateSetMobile } from "components/create-set-variant";
const CreateSet = ({
  variants,
  createSetVariants, setCreateSetVariants,
  setTotalPrice, totalPrice,
  totalCompareAtPrice, setTotalCompareAtPrice
}) => {

  const addVariantToCart = (variant) => {
    const variantAdded = createSetVariants[variant.id];
    const variantPrice = parseFloat(variant.price);
    const variantPriceAtCompare = parseFloat(variant?.compareAtPrice);
    setTotalPrice(variantAdded ? (totalPrice - variantPrice) : (totalPrice + variantPrice));

    if (variantPriceAtCompare > 0) {
      setTotalCompareAtPrice(variantAdded ?
        totalCompareAtPrice - variantPriceAtCompare :
        totalCompareAtPrice + variantPriceAtCompare
      );
    } else {
      setTotalCompareAtPrice(variantAdded ?
        totalCompareAtPrice - variantPrice :
        totalCompareAtPrice + variantPrice
      );
    }

    if (variantAdded) {
      setCreateSetVariants(prevState => {
        Object.keys(prevState).forEach(id => {
          if (id === variant.id) {
            delete prevState[id];
          }
        });

        return prevState;
      });
    } else {
      setCreateSetVariants({
        ...createSetVariants,
        [variant.id]: { "id": variant.id }
      });
    }
  };


  return (
    <div className={createSetContainerDesktop}>
      {variants?.length && (<>
        {variants?.map(v =>
          <CreateSetDesktop
            key={v._key}
            upsell={v}
            onClick={() => addVariantToCart(v.variant)}
            variantAdded={createSetVariants[v?.variant?.id]}
            plusPrice={v.variant.price}
          />
        )}
        <Swiper
          slidesPerView={2.8}
          modules={[Pagination]}
          spaceBetween={20}
          loop={true}
          centeredSlides={true}
          pagination={{ clickable: true }}
          className={createSetMobile}>
          {variants.map(v =>
            <SwiperSlide key={v._key}>
              <CreateSetMobile
                upsell={v}
                onClick={() => addVariantToCart(v.variant)}
                variantAdded={createSetVariants[v.variant.id]}
                plusPrice={v.variant.price}
              />
            </SwiperSlide>
          )}
        </Swiper>
      </>)}
    </div>
  );
};

export default CreateSet;
